import styled from 'styled-components';
import { getStateColor } from "../../utils/getStateColor";
export const TabContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 56px;
  padding: 8px;
  cursor: grab;
  /* 
  // Tooltip:
  position: relative;

  [data-tooltip]:before {
    content: attr(data-tooltip);
    position: absolute;
    opacity: 0;

    transition: all 0.15s ease;
    padding: 5px;
    color: #ffffff;
    ${_ref => {
  let {
    theme
  } = _ref;
  return theme.fonts.labelSM;
}}
    border-radius: 10px;
  }

  [data-tooltip]:hover:before {
    opacity: 1;

    background: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return `${theme.colors.primaryD2}`;
}};
    margin-top: -20px;
  }
 */
`;
export const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  gap: 8px;
  padding: 12px;
  height: 40px;
  border-radius: 50px;

  background-color: ${_ref3 => {
  let {
    theme,
    selected
  } = _ref3;
  return selected ? theme.colors.primaryD1 : 'transparent';
}};

  transition: background-color 0.2s ease-in-out;

  ${_ref4 => {
  let {
    disabled
  } = _ref4;
  return disabled && 'opacity: 0.5; cursor: not-allowed;';
}}

  &:hover {
    background-color: ${_ref5 => {
  let {
    theme,
    selected,
    disabled
  } = _ref5;
  return selected && !disabled ? getStateColor(theme.colors.primaryD1, 'hover') : getStateColor(theme.colors.secondaryD2, 'hover');
}};

    cursor: ${_ref6 => {
  let {
    disabled
  } = _ref6;
  return disabled ? 'not-allowed' : 'pointer';
}};
  }

  &:focus {
    outline: 0;
    border: 0;
    background-color: ${_ref7 => {
  let {
    theme,
    selected
  } = _ref7;
  return selected ? getStateColor(theme.colors.primaryD1, 'focused') : getStateColor(theme.colors.secondaryD2, 'focused');
}};
  }

  &:active {
    ${_ref8 => {
  let {
    theme,
    disabled
  } = _ref8;
  return !disabled && getStateColor(theme.colors.secondaryD2, 'pressed');
}}
  }
`;
export const Label = styled.span`
  ${_ref9 => {
  let {
    theme
  } = _ref9;
  return theme.fonts.infoSM;
}}
  color: ${_ref10 => {
  let {
    theme
  } = _ref10;
  return theme.colors.neutralL5;
}};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  user-select: none;
`;